<template>
  <div id="account-table">
    <b-table
      v-if="documentSelected !== 5"
      :items="items.data"
      :fields="fields"
      striped
      responsive
      bordered
      :tbody-tr-class="rowClass"
    >
      <template slot="no" slot-scope="data">
        <div class="col-right">
          {{ data.index + items.from }}
        </div>
      </template>
      <template slot="เลขที่" slot-scope="data">
        <div class="col-right">
          <a @click="goDocument(data.item.id)">
            <u>{{ documentSelected === 2 ? data.item.ti : data.item.in }}</u>
          </a>
        </div>
      </template>
      <template slot="วันที่ออกเอกสาร" slot-scope="data">
        <div class="col-center">
          {{ data.item.created_date }}
        </div>
      </template>
      <template slot="รายชื่อลูกค้า" slot-scope="data">
        <div class="col-left">
          <a
            @click="
              setCustomerData(data.item.hospital_id).then(
                goHistoryCustomerAdding
              )
            "
          >
            <u>{{
              data.item.hospital_name || data.item.custom_hospital_name
            }}</u>
          </a>
        </div>
      </template>
      <template slot="จำนวน LN" slot-scope="data">
        <div class="col-right">
          {{ $numeral(data.item.ln_amount).format("0,0") }}
        </div>
      </template>
      <template slot="จำนวนตรวจ" slot-scope="data">
        <div class="col-right">
          {{ $numeral(data.item.test_amount).format("0,0") }}
        </div>
      </template>
      <template slot="ราคารวม" slot-scope="data">
        <div class="col-right">
          {{
            $numeral(
              parseFloat(data.item.price_amount) +
                parseFloat(data.item.to_amount)
            ).format("0,0[.]00")
          }}
        </div>
      </template>
      <template slot="สถานะ" slot-scope="data">
        <div class="col-left">
          <a
            v-if="
              data.item.payment_status
                ? data.item.payment_status.name !== 'ยกเลิก'
                : true
            "
            :class="{
              pay: data.item.is_pay,
              'not-pay': data.item.payment_status
                ? data.item.payment_status.name === 'รอจ่าย'
                : true,
              'cancel-pay': data.item.payment_status
                ? data.item.payment_status.name === 'ยกเลิก'
                : false,
            }"
            @click="setDocument(data.item.id).then(openPaymentModal)"
          >
            <u>{{
              data.item.payment_status
                ? data.item.payment_status.name
                : " รอจ่าย"
            }}</u>
          </a>
          <u
            v-else-if="
              data.item.payment_status
                ? data.item.payment_status.name === 'ยกเลิก'
                : false
            "
            class="cancel-pay"
            >ยกเลิก</u
          >
        </div>
      </template>
      <template slot="บันทึกโดย" slot-scope="data">
        <div class="col-left">
          {{ data.item.created_by ? data.item.created_by.name : "" }}
        </div>
      </template>
      <template slot="แก้ไขล่าสุดโดย" slot-scope="data">
        <div class="col-left">
          {{ data.item.updated_by ? data.item.updated_by.name : "" }}
        </div>
      </template>
      <template slot="วันที่แก้ไขล่าสุด" slot-scope="data">
        <div class="col-center">
          {{
            data.item.latest_updated
              ? data.item.latest_updated.created_at
              : data.item.updated_at
          }}
        </div>
      </template>
      <template slot="ออกรายงาน" slot-scope="data">
        <b-button
          class="print-order-btn mx-1 my-1"
          @click="printed(data.item.id, false)"
        >
          พิมพ์ฉบับจริง
        </b-button>
        <b-button
          class="print-order-btn mx-1 my-1"
          @click="printed(data.item.id, true)"
        >
          พิมพ์สำเนา
        </b-button>
      </template>
      <template slot="แก้ไข" slot-scope="data">
        <b-button
          class="edit-order-btn"
          :disabled="
            data.item.payment_status
              ? data.item.payment_status.name !== 'รอจ่าย'
              : false
          "
          @click="goDocument(data.item.id)"
        >
          แก้ไข
        </b-button>
      </template>
      <template slot="ลบ" slot-scope="data">
        <b-button
          :disabled="
            (data.item.payment_status
              ? data.item.payment_status.name !== 'ยกเลิก'
              : false) || data.item.is_pay
          "
          class="del-order-btn"
          @click="deleteDocument(data.item.id)"
        >
          ลบ
        </b-button>
      </template>
    </b-table>
    <b-table
      v-else
      :fields="blankFormFields"
      :items="items.data"
      striped
      bordered
      :tbody-tr-class="rowClass"
    >
      <template slot="no" slot-scope="data">
        <div class="col-right">
          {{ data.index + items.from }}
        </div>
      </template>
      <template slot="หัวกระดาษ" slot-scope="data">
        <div class="col-left">
          {{ data.item.has_header ? "มีหัวกระดาษ" : "ไม่มีหัวกระดาษ" }}
        </div>
      </template>
      <template slot="หัวข้อ" slot-scope="data">
        <div class="col-left">
          {{ data.item.title }}
        </div>
      </template>
      <template slot="วันที่ออกเอกสาร" slot-scope="data">
        <div class="col-center">
          {{ data.item.created_date }}
        </div>
      </template>
      <template slot="บันทึกโดย" slot-scope="data">
        <div class="col-left">
          {{ data.item.creator ? data.item.creator.name : "" }}
        </div>
      </template>
      <template slot="ออกรายงาน" slot-scope="data">
        <b-button
          class="print-order-btn"
          @click="printedBlankForm(data.item.id)"
        >
          ออกเอกสาร
        </b-button>
      </template>
      <template slot="แก้ไข" slot-scope="data">
        <!--        <b-button-->
        <!--                class="edit-order-btn"-->
        <!--                @click="goBlankForm(data.item.id)"-->
        <!--        >แก้ไข</b-button>-->
        <blank-document-form-modal :id="data.item.id" :modal-type="'edit'" />
      </template>
      <template slot="ลบ" slot-scope="data">
        <b-button
          class="del-order-btn"
          @click="confirmDeleteBlankForm(data.item.id)"
        >
          ลบ
        </b-button>
      </template>
    </b-table>
    <div v-if="items.data ? items.data.length <= 0 : true">ไม่พบข้อมูล</div>
    <b-pagination
      v-model="items.current_page"
      size="md"
      :total-rows="items.total"
      :per-page="items.per_page"
      @change="getDataPerPage"
    />
    <b-modal ref="cancelModal" />
    <b-modal
      id="paymentModal"
      ref="paymentModal"
      centered
      title="ยืนยันการชำระเงิน"
      ok-variant="success"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      size="lg"
      @ok="payment"
    >
      <payment-modal-component
        v-if="documentDetail"
        :payload.sync="payload"
        :payment-list="paymentList"
        :document-detail="documentDetail"
        :payment-date.sync="paymentDate"
        :payment-methods-selected.sync="paymentMethodsSelected"
        :payment-status-selected.sync="paymentStatusSelected"
        :check-number.sync="checkNumber"
        :is-check-method="isCheckMethod"
      />
    </b-modal>
    <notifications group="alert" position="bottom right" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PaymentModalComponent from "../../components/Account/PaymentModalComponent";
import BlankDocumentFormModal from "../../components/Account/BlankDocumentFormModal";
import moment from "moment-timezone";
import format from "date-fns/format";
import printJS from "print-js";

export default {
  name: "AccountTable",
  components: {
    PaymentModalComponent,
    BlankDocumentFormModal,
  },
  props: {
    documentSelected: {
      type: Number,
    },
    filters: {
      type: Function,
    },
  },
  computed: {
    ...mapGetters({
      items: "Account/getFilterDocument",
      documentDetail: "Account/getDocumentDetail",
      paymentStatus: "Account/getPaymentStatuses",
      platforms: "Account/getPlatforms",
      documentTypes: "Account/getFilterDocumentType",
    }),
    documentFilter: {
      get() {
        return this.$store.state.Account.documentFilter;
      },
      set(val) {
        this.$store.commit("Account/SET_DOCUMENT_FILTER", val);
      },
    },
    corporationSelected: {
      get() {
        return this.$store.state.Account.corporationId;
      },
      set(val) {
        this.$store.commit("Account/SET_CORPORATION_ID", val);
      },
    },
  },
  data() {
    return {
      fields: [
        "no",
        "เลขที่",
        "วันที่ออกเอกสาร",
        "รายชื่อลูกค้า",
        // A column that needs custom formatting
        "จำนวน LN",
        "จำนวนตรวจ",
        // A regular column
        "ราคารวม",
        // A regular column
        "สถานะ",
        "บันทึกโดย",
        "แก้ไขล่าสุดโดย",
        // A virtual column made up from two fields
        "วันที่แก้ไขล่าสุด",
        "ออกรายงาน",
        "แก้ไข",
        "ลบ",
      ],
      blankFormFields: [
        "no",
        "หัวกระดาษ",
        "หัวข้อ",
        "วันที่ออกเอกสาร",
        "บันทึกโดย",
        "ออกรายงาน",
        "แก้ไข",
        "ลบ",
      ],
      paymentList: [],
      payload: {
        paymentDate: null,
        paymentMethod: null,
        paymentStatus: null,
        checkNumber: null,
      },
      paymentDate: "",
      paymentMethodsSelected: "", // Must be an array reference!
      paymentStatusSelected: "",
      checkNumber: "",
      isCheckMethod: false,
      // blankDocument: null
    };
  },
  methods: {
    rowClass(item, type) {
      if (item.emergency_level == 1) {
        return "highlight";
      } else {
        return;
      }
    },
    ...mapActions({
      setCustomerData: "Hospital/setData",
      setReadOnly: "Order/setReadOnly",
      setAdding: "History/setAdding",
      setDocument: "Account/setDocument",
      deleteDocumentService: "Account/deleteDocument",
      paymentService: "Account/payment",
      setFilterDocument: "Account/setFilterDocument",
      checkPermission: "Order/checkPermission",
      getBlankForm: "Account/getBlankForm",
      deleteBlankForm: "Account/deleteBlankForm",
      printDocument: "Account/printDocument",
    }),
    async permission(type, mod) {
      let permission = await this.checkPermission({
        type: type,
        mod: mod,
      });

      if (!permission) {
        this.$notify({
          group: "alert",
          title: "มีข้อผิดพลาดบางอย่าง",
          text: permission,
          position: "bottom right",
          type: "error",
        });
        return false;
      }
      return true;
    },
    async goResultDetail(idOut, idAnimal, idHospital, readOnly) {
      await this.setCustomerData(idHospital);
      this.setReadOnly(readOnly);
      this.$router.push({
        name: "result-detail",
        params: { read: readOnly },
      });
    },
    goHistoryCustomerAdding() {
      const addingCustomer = false;
      const addingAnimal = false;
      this.setAdding({ addingCustomer, addingAnimal });
      this.$router.push({ name: "history-customer-adding" });
    },
    async getDataPerPage(pageNo) {
      // console.log('page no', pageNo)
      this.$store.state.isLoading = true;
      this.documentFilter.page_no = pageNo;
      this.documentFilter.current_page = pageNo;
      this.$store.state.isLoading = true;
      await this.filters(this.documentFilter);
      this.$store.state.isLoading = false;
    },
    async openPaymentModal() {
      let permission = await this.permission("accountant", "can_payment");

      if (permission) {
        this.initializePaymentList();
        //   console.log();
        this.$refs.paymentModal.show();
      }
    },
    goDocument(id) {
      this.$router.push({
        name: "document",
        query: {
          id: id,
        },
      });
    },
    async deleteDocument(id) {
      let permission = await this.permission("accountant", "can_delete");
      // console.log("delete", id);

      if (permission) {
        const confirm = await this.$swal.fire({
          title: "ยืนยันการลบ",
          text: `คุณต้องกาลบรายการนี้ใช่หรือไม่?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "ลบ",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
        });

        if (confirm.value) {
          this.$store.state.isLoading = true;
          let res = await this.deleteDocumentService(id);

          if (res) {
            await this.filters(this.documentFilter);
          }
          this.$swal.fire("สำเร็จ", "เพิ่มรายการเรียบร้อย", "success");
          this.$store.state.isLoading = false;
        }
      }
    },
    async printedBlankForm(id) {
      let permission = await this.permission("accountant", "can_print");

      if (permission) {
        await this.$nextTick().then(async () => {
          await this.$nextTick().then(async () => {
            printJS({
              printable: `${process.env.VUE_APP_IP}blank-form-print/${id}`,
              type: "pdf",
              showModal: true,
            });
          });
        });
        // printJS({printable:`${process.env.VUE_APP_IP}blank-form-print/${id}`, showModal:true, base64: true, type: "pdf"})
      }
    },
    async printed(id, isCopy = null) {
      let permission = await this.permission("accountant", "can_print");

      if (permission) {
        // alert(`printed document id: ${id}`);
        //  documentSelected

        // let platform = this.platforms.find((platform) => platform.id === this.corporationSelected)
        // let documentType = this.documentTypes.find((documentType) => documentType.id === this.documentSelected)
        // let pageSetting = `@page {size: ${documentType.paper_size} ${documentType.orientation.toLowerCase()}}`
        // console.log(pageSetting)
        this.$store.state.isLoading = true;

        let printResponse;
        try {
          printResponse = await this.printDocument({
            documentSelected: this.documentSelected,
            id,
            isCopy,
          });
        } catch (error) {
          this.$swal.fire("Error", error, "error");
          this.$store.state.isLoading = false;
          return;
        }

        this.$store.state.isLoading = false;
        window.open(printResponse.result.url);
        // let res = await fetch(`${process.env.VUE_APP_IP}document-print/${this.documentSelected}?id=${id}\``);

        // const myJson = await res.json();
        // console.log(myJson);
        //
        // printJS({
        //   printable: myJson,
        //   type: "pdf",
        //   showModal: true,
        //   base64: true
        // });
        // printJS({printable:`${process.env.VUE_APP_IP}document-print/${this.documentSelected}?id=${id}`, showModal:true, base64: true, type: "pdf"})
      }
    },
    initializePaymentList() {
      this.paymentList = [];
      this.paymentStatusSelected = 1;
      this.paymentMethodsSelected = "cash";
      var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
      this.paymentDate = today;
      document.getElementById("payment-date").value = format(
        today,
        this.dateFormat
      );
      this.checkNumber = "";

      if (this.documentDetail.product_type === "lab") {
        if (this.documentDetail.lab_invoices.length > 0) {
          let testPayment = {
            name: "ค่าบริการตรวจทางห้องปฏิบัติการสัตวแพทย์",
            quantity: this.documentDetail.test_amount,
            amount:
              parseFloat(this.documentDetail.price_amount) +
              parseFloat(this.documentDetail.to_amount) -
              parseFloat(this.documentDetail.promotion_price),
            duePayment: this.documentDetail.due_date,
          };
          this.paymentList.push(testPayment);
        }
      } else {
        this.documentDetail.items.forEach((item) => {
          let testPayment = {
            name: `${item.item.name}`,
            quantity: item.quantity,
            amount: +item.quantity * +item.price,
            duePayment: this.documentDetail.due_date,
          };
          this.paymentList.push(testPayment);
        });
      }

      // console.log('payment', this.paymentList)

      if (this.documentDetail.payment.length > 0) {
        let latestPayment = this.documentDetail.payment[
          this.documentDetail.payment.length - 1
        ];

        // console.log(latestPayment);

        var date = moment(latestPayment.payment_date.split(" ")[0]).format(
          "YYYY-MM-DD"
        );
        this.paymentDate = date;

        this.paymentMethodsSelected = latestPayment.payment_method;
        if (this.paymentMethodsSelected == "check") {
          this.isCheckMethod = true;
        }
        this.paymentStatusSelected = latestPayment.payment_status_id;
        this.checkNumber = latestPayment.check_number;
      }
    },
    async payment() {
      if (!this.payload.paymentDate) {
        await this.$swal.fire("คำเตือน", "กรุณาเลือกวันชำระเงิน", "warning");
        return;
      }
      if (!this.payload.paymentStatus) {
        await this.$swal.fire(
          "คำเตือน",
          "กรุณาเลือกสถานะการจ่ายเงิน",
          "warning"
        );
        return;
      }
      if (this.payload.paymentMethod) {
        if (
          this.payload.paymentMethod === "check" &&
          !this.payload.checkNumber
        ) {
          await this.$swal.fire("คำเตือน", "กรุณากรอกเลขที่เช็ค", "warning");
          return;
        }
      }
      if (this.payload.paymentStatus == 2) {
        if (!this.payload.paymentMethod) {
          await this.$swal.fire(
            "คำเตือน",
            "กรุณากรอกรูปแบบการจ่ายเงิน",
            "warning"
          );
          return;
        }
      }
      this.$store.state.isLoading = true;
      let res = await this.paymentService({
        id: this.documentDetail.id,
        ...this.payload,
      });
      if (res) {
        await this.filters(this.documentFilter);
        await this.$swal.fire("สำเร็จ", "บันทึกสถานะใหม่เสร็จสิ้น", "success");
      }
      this.$store.state.isLoading = false;
    },
    async ankForm(id) {
      let permission = await this.permission("accountant", "can_print");

      if (permission) {
        await this.$nextTick().then(async () => {
          await this.$nextTick().then(async () => {
            printJS({
              printable: `${process.env.VUE_APP_IP}blank-form-print/${id}`,
              type: "pdf",
              showModal: true,
            });
          });
        });
      }
    },
    async confirmDeleteBlankForm(id) {
      this.$bvModal
        .msgBoxConfirm("คุณต้องการจะลบแบบฟอร์มใช่ไหม", {
          title: "ยืนยันการลบแบบฟอร์ม",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteBlankForm(id);
            await this.filters(this.documentFilter);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    async blankDocument(id) {
      return await this.getBlankForm(id);
    },
  },
  watch: {
    paymentMethodsSelected(newVal, oldVal) {
      if (newVal === "check") {
        this.isCheckMethod = true;
      } else {
        this.isCheckMethod = false;
        this.checkNumber = "";
      }
      //   console.log(newVal);
      var payload = this.payload;
      payload.paymentMethod = newVal;
      payload.paymentDate = this.paymentDate;
      payload.paymentStatus = this.paymentStatusSelected;
      payload.checkNumber = this.checkNumber;

      //   this.$emit("update:payload", payload);
      this.payload = payload;
    },
    paymentDate(newVal, oldVal) {
      var payload = this.payload;
      payload.paymentDate = newVal;
      payload.paymentMethod = this.paymentMethodsSelected;
      payload.paymentStatus = this.paymentStatusSelected;
      payload.checkNumber = this.checkNumber;

      //   this.$emit("update:payload", payload);
      this.payload = payload;
    },
    paymentStatusSelected(newVal, oldVal) {
      var payload = this.payload;
      payload.paymentStatus = newVal;
      payload.paymentMethod = this.paymentMethodsSelected;
      payload.paymentDate = this.paymentDate;
      payload.checkNumber = this.checkNumber;

      //   this.$emit("update:payload", payload);
      this.payload = payload;
    },
    checkNumber(newVal, oldVal) {
      var payload = this.payload;
      payload.checkNumber = newVal;
      payload.paymentMethod = this.paymentMethodsSelected;
      payload.paymentDate = this.paymentDate;
      payload.paymentStatus = this.paymentStatusSelected;
      //   this.$emit("update:payload", payload);
      this.payload = payload;
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: black;
  cursor: pointer;
}
.print-order-btn {
  background-color: #fb822b;
  min-width: 150px;
  border: none;
}
.edit-order-btn {
  background-color: #2e83d9;
  border: none;
}
.del-order-btn {
  background-color: #e20000;
  border: none;
}
.del-order-btn:disabled {
  background-color: #ffc3c8;
  border: none;
}
.pay {
  color: #009906 !important;
}
.not-pay {
  color: #e20000 !important;
}
.cancel-pay {
  color: rgba(0, 0, 0, 0.23) !important;
}
.icon {
  cursor: pointer;
}
</style>
